module.exports = {
      id: "apple-podcast-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-0ef3134280a050ca46b4726dfe0fed42.svg#apple-podcast",
      toString: function () {
        return this.url;
      }
    }